const icons = {
    list: <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-numbers" width="20"
               height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
               strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M11 6h9"></path>
        <path d="M11 12h9"></path>
        <path d="M12 18h8"></path>
        <path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"></path>
        <path d="M6 10v-6l-2 2"></path>
    </svg>,
    create_contact : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-person-rolodex" viewBox="0 0 16 16">
    <path d="M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
    <path d="M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1z"/>
  </svg>
}

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const contacts = {
    id: 'contacts',
    title: 'Contacts',
    type: 'group',
    role: [1, 2, 3],
    children: [
        {
            id: '/contact/list',
            title: 'Contact List',
            type: 'item',
            url: '/contact/list',
            icon: icons.list,
            role: [1, 2, 3],
            breadcrumbs: false
        },
        {
            id: '/contact/create',
            title: 'Create Contact',
            type: 'item',
            url: '/contact/create',
            icon: icons.create_contact,
            role: [1],
            breadcrumbs: false
        },
    ]
};

export default contacts;
